
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ApiurlManage',
  setup() {},
});
